import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  MeQueryQuery,
} from "../../schemaTypes";

export const meQuery = gql`
  query MeQuery {
    me {
      id
      customer{
        id
        avatarUrl
        firstname
        lastname
        email
        username
        phone
        community{
          id
          name
          alias
        }
        createdAt
        updatedAt
        address
        gender
        dob
        nin
      }
      admin {
        id
        shortId
        firstname
        lastname
        email
        phone
        level
        merchantProfile {
          id
          businessName
          businessType
          regCountry
          businessRegNumber
          taxId
          address
          addressAlt
          city
          country
          postcode
          companyName
          username
          industry {
            id
            name
            createdBy{
              id
              role
            }
            createdAt
            updatedAt
          }
          companyLocation
          logoUrl
          bannerUrl
          description
          commissionRate
          websiteOrSocials
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      # kycStatus
      suspended
      isLocked
      isVerified
      # forgotPasswordLocked
      onboarding{
        id
        status
        currentStep
      }
      role
      # lastLoggedIn
      # createdAt
      # updatedAt
    }
  }
`;

export interface WithMe {
  match: MeQueryQuery['me'] | null;
  loading: boolean;
}

interface Props {
  children: (data: WithMe) => React.ReactElement | null;
}

export const ViewMe: React.FC<Props> = ({ children }) => {
  const { data, loading } = useQuery<MeQueryQuery>(meQuery);

  // let match: User | null = null;
  let match: MeQueryQuery['me'] | null = null;
  if (data && data.me) {
    match = data.me;
  }

  return children({
    match,
    loading
  });
};